<template>
  <div>
    <label>{{ label }}</label>
    <label
      class="bool-switch"
      :for="idcss"
    >
      <input
        :id="idcss"
        type="checkbox"
        :checked="checked"
        @input="change"
      >
      <span class="bool-switch_slider" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitchSimple',
  props: {
    label: String,
    idcss: String,
    value: [String, Number, Boolean]
  },
  data () {
    return { check: 0 }
  },
  computed: {
    checked () {
      return (+this.check)
    }
  },
  mounted () {
    this.check = +this.value
  },
  methods: {
    change () {
      this.check = !this.check
      this.$emit('input', +this.check)
    }
  }
}
</script>

<style lang="scss" scoped>
  /* bollean swither style */
  label.bool-switch {
    position: relative;
    display: inline-block !important;
    width: 60px;
    height: 34px;
    margin: 3px 5px 3px 0;
    cursor: pointer;
    z-index: 5;
  }

  label.bool-switch input {
    opacity: 0;
    width: 0;
    height: 0;
    z-index: 9;
  }

  label.bool-switch .bool-switch_slider {
    position: absolute;
    z-index: 6;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 30px;
  }

  label.bool-switch .bool-switch_slider:before {
    position: absolute;
    z-index: 6;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }

  label.bool-switch input:checked + .bool-switch_slider {
    background-color: #68B3C8;
  }

  label.bool-switch input:focus + .bool-switch_slider {
    box-shadow: 0 0 1px #68B3C8;
  }

  label.bool-switch input:checked + .bool-switch_slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  /* end bollean swither style */
</style>
